<div class="notification-item">
  <mat-icon svgIcon="info"></mat-icon>
  <div class="font-caption-default font-medium" [innerHTML]="messageHtml()"></div>
</div>
